module.exports = __webpack_public_path__ + "static/media/1.e0b34f6f.jpg";